import { SquarePen } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Page } from "@/components/Page";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { HOME_PATH, Link } from "../router.tsx";
import { ConversationList } from "./ConversationList.tsx";

/**
 * `/conversations` (spec `web-shell` "Conversations page"): every conversation the user can
 * open, in their projects and outside any project, each naming its project or "No project".
 */
export function ConversationsPage() {
  const { t } = useTranslation();
  return (
    <Page className="gap-6">
      <PageHeader
        title={t("nav.conversations")}
        lead={t("conversationList.lead")}
        actions={
          <Button asChild size="sm" variant="outline">
            <Link href={HOME_PATH}>
              <SquarePen aria-hidden="true" strokeWidth={1.75} />
              {t("nav.newChat")}
            </Link>
          </Button>
        }
      />
      <ConversationList showProject />
    </Page>
  );
}
